import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useSectionRefs } from "../../../hooks/useSectionRefs";
import TagsAnchorContainer from "../TagsAnchorContainer";

const HelpTopicAnnutionInscription = () => {
  const { windowWidth } = useContext(dataApplicationsContext);

  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Vos inscriptions', link: '/topics/inscription'},
    { label: 'Annulations', link: '/topics/inscription/annulations'},
    { label: topic.title, link: topic.link},
  ];

  // <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/events`}>vos inscriptions.</a>
  
  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Vos projets ont changé et vous souhaitez maintenant annuler votre inscription. Voici comment faire.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Malheureusement, nos athlètes ne peuvent pas encore annuler eux-mêmes une inscription à une compétition.
              </p>
              <p className="help-text">
                Si vous ne pouvez pas être présent lors de la compétition, il est préférable de
                <a target='_blank' className="link" href={`/topics/rechercher/34`}>prévenir</a>directement 
                les organisateurs. Ils pourront ainsi prendre les mesures nécessaires pour annuler votre inscription.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Le règlement intérieur et les conditions générales d’inscription sont entièrement définis par les  
                <strong> organisateurs.</strong> Vous devez alors prendre  
                <a target='_blank' className="link" href={`/topics/rechercher/34`}>contact</a>avec les organisatezurs pour en faire la demande.
              </p>
              <p className="help-text">
                Wodzone n’intervient pas dans la gestion des remboursements. Les modalités de remboursement sont précisées 
                dans les conditions générales de la compétition. Pour plus d’informations, consulter notre
                <a target='_blank' className="link" href={`#`}>article dédié.</a>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicAnnutionInscription